$(document).ready(function() {
    // Toggle read more/less for artist section
    $(".moreless-button-artist").click(function(event) {
        event.preventDefault(); // Prevent the default anchor click behavior
        var $this = $(this); // Cache 'this' to use in the callback

        $(".artistmain-section").toggleClass("readmore-active");

        // Immediately toggle the text of the button
        $this.text($this.text() === "Read More" ? "Read Less" : "Read More");

        // Toggle the visibility of the additional text smoothly
        $(".moretext-artist").slideToggle(400);
    });

    // Toggle read more/less for style guide section
    $(".moreless-button-styleguide").click(function(event) {
        event.preventDefault(); // Prevent the default anchor click behavior
        var $this = $(this); // Cache 'this' to use in the callback

        // Immediately toggle the text of the button
        $this.text($this.text() === "Read More" ? "Read Less" : "Read More");

        // Toggle the visibility of the additional text smoothly
        $(".moretext-styleguide").slideToggle(400);
    });


    // Toggle product description section visibility
$(document).on("click", "#toggledescription", function(event) {
    event.preventDefault();

    var $this = $(this);
    var $content = $(".moretext-description");

    if ($content.is(":visible")) {
        $content.stop(true, true).slideUp(400);
        $this.text("Read More");
    } else {
        $content.stop(true, true).slideDown(400);
        $this.text("Read Less");
    }
});

    // Toggle artist section visibility
    $("#toggleartist").click(function() {
        var elem = $("#toggleartist").text();
        if (elem == "Read More") {
            $(this).text("Read Less");
            $(".moretext-artist").slideDown();
        } else {
            $(this).text("Read More");
            $(".moretext-artist").slideUp();
        }
    });

    // Toggle style guide section visibility
    $("#togglestyle").click(function() {
        var elem = $("#togglestyle").text();
        if (elem == "Read More") {
            $(this).text("Read Less");
            $(".moretext-styleguide").slideDown();
        } else {
            $(this).text("Read More");
            $(".moretext-styleguide").slideUp();
        }
    });

    // Accordion functionality
    const items = document.querySelectorAll(".accordion button");

    function toggleAccordion() {
        const itemToggle = this.getAttribute("aria-expanded");

        for (i = 0; i < items.length; i++) {
            items[i].setAttribute("aria-expanded", "false");
        }

        if (itemToggle == "false") {
            this.setAttribute("aria-expanded", "true");
        }
    }

    items.forEach((item) => item.addEventListener("click", toggleAccordion));
});

// Toggle artist and style class
document.getElementById('toggleartist').addEventListener('click', function() {
    this.classList.toggle('Readmoreactive');
});
document.getElementById('togglestyle').addEventListener('click', function() {
    this.classList.toggle('Readmoreactivestyle');
});

// Mute video on page load
document.addEventListener("DOMContentLoaded", function() {
    var video = document.getElementById("myVideo");
    video.muted = true;
});

// Add out of stock class if the product is out of stock
document.addEventListener("DOMContentLoaded", function() {
    var stockStatusElement = document.querySelector('.sold-out-badge');

    if (stockStatusElement && stockStatusElement.textContent.includes('Out Of Stock')) {
        document.body.classList.add('outofstock');
    }
});

// Add color name text after swatch radio input
// document.addEventListener('DOMContentLoaded', function() {
//     // Select all radio inputs within the swatch container
//     const radioInputs = document.querySelectorAll('.product-form__swatch .swatch-container .product-form__radio');

//     radioInputs.forEach(function(input) {
//         // Create a new span element for the color name
//         let colorNameSpan = document.createElement('span');
//         colorNameSpan.className = 'color-name-text';
//         // Set the text content to the input's value, which is the color name
//         colorNameSpan.textContent = input.value;

//         // Insert the color name span after the radio input
//         input.parentNode.insertBefore(colorNameSpan, input.nextSibling);
//     });
// });

// Replace text with image and add "View All" button in the navigation
document.addEventListener("DOMContentLoaded", function() {
    // Get the element that contains the text you want to replace
    var siteNavList = document.querySelector('.site-nav.data-submenu-super-deal .site-nav-list');

    if (siteNavList) {
        // Create an image element for the menu item
        var img = document.createElement('img');
        img.src = 'https://cdn.shopify.com/s/files/1/0565/7467/2947/files/shopimage.png?v=1711951912'; // Replace with the actual URL of the uploaded image
        img.alt = 'Super Deal';
        img.classList.add('submenu-image');

        // Create an anchor element for the "View All" button
        var viewAllLink = document.createElement('a');
        viewAllLink.href = '/collections/super-deal'; // Set the href to the link you want the button to go to
        viewAllLink.classList.add('view-all-button');
        viewAllLink.innerHTML = '<span>View All </span>';

        // Append the small arrow image to the link
        var arrowImg = document.createElement('img');
        arrowImg.src = 'https://cdn.shopify.com/s/files/1/0565/7467/2947/files/Arrow.png?v=1711954480'; // Replace with the URL of your small arrow image
        arrowImg.alt = 'Arrow';
        arrowImg.classList.add('small-arrow');

        // Append the image and arrow to the link
        viewAllLink.appendChild(arrowImg);

        // Replace the text with the image and append the "View All" link
        siteNavList.innerHTML = ''; // Clear the existing content
        siteNavList.appendChild(img);
        siteNavList.appendChild(viewAllLink);
    }
});
